import chunk from "lodash/chunk";

export const getTextColorForBackground = (hexColor) => {
  if (!hexColor) return "#4c4e55";

  const [r, g, b] = chunk(hexColor.substring(1, 6).split(""), 2)
    .map((pair) => pair.join(""))
    .map((hex) => parseInt(`0x${hex}`));
  const brightness = r * 0.299 + g * 0.587 + b * 0.114;
  return brightness > 150 ? "#4c4e55" : "#ffffff";
};

export const rgbToHex = (rgbString) => {
  if (!rgbString) return "#ffffff";
  const [red, green, blue] = rgbString.substring(4, rgbString.length - 1).split(", ");
  const rgb = (red << 16) | (green << 8) | (blue << 0);
  return "#" + (0x1000000 + rgb).toString(16).slice(1);
};

export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 240, g: 240, b: 240 };
};

export const hexToRgba = (hex, opacity) => {
  const rgb = hexToRgb(hex);
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
};

export const generateVisitedBackground = (color) => {
  const colorA = hexToRgba(color, 0.6);
  const colorB = hexToRgba(color, 1);
  return `repeating-linear-gradient(
    45deg,
    ${colorA},
    ${colorA} 10px,
    ${colorB} 10px,
    ${colorB} 20px
  )`;
};
